import type {ReactElement} from 'react';
import React from 'react';
import {BaseVectorColorOpacityOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-vector-color-opacity-option';
import {VectorFillThumbnailOption} from '@Panels/poster-editor-vector-fill-panel/components/vector-fill-thumbnail-option';
import {VectorFillColorSection} from '@Panels/poster-editor-vector-fill-panel/components/vector-fill-color-section';
import {ContextualMenu} from '@Components/contextual-menu';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';
import {getAlphaFromFabricColor} from '@Utils/color.util';

interface VectorFillOptionsProps {
  panelId: string;

  onClickColorFill(index: number): void;
}

export function VectorFillOptions({...props}: VectorFillOptionsProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fill = useGetKeyFromActiveItem('fill');

  if (!activeItem) {
    return null;
  }

  if (fill === undefined) {
    return null;
  }

  if (!activeItem.isVector() && !activeItem.isRectangle()) {
    return null;
  }

  const onUpdateOpacity = (val: number, undoable = true): void => {
    activeItem.updateFillColorOpacity(val, undoable);
  };

  const getFillOpacityOption = (): ReactElement | null => {
    if (fill === null) {
      return null;
    }

    return <BaseVectorColorOpacityOption className="spacing-m-b-4 spacing-m-t-4" fillAlpha={getAlphaFromFabricColor(fill)} onChangeOpacity={onUpdateOpacity} />;
  };

  return (
    <ContextualMenu id="vector-fill-panel" hasMobileModalPadding hasMobileMorphingProperties>
      <VectorFillColorSection
        onClickColorFill={(index): void => {
          props.onClickColorFill(index);
        }}
      />
      {getFillOpacityOption()}
      <VectorFillThumbnailOption panelId={props.panelId} />
    </ContextualMenu>
  );
}
